<template>
  <h1 class="title" style="margin-top: 20px; margin-left: 5px; display:flex;">
    <p
      :class="current === 'TASKS' ? 'active' : ''"
      @click="redirectToUserProcess('TASKS')"
    >
      Zadania
    </p>
    <p
      v-for="option in processTypes"
      :key="option"
      style="margin-left:40px;"
      :class="option == current ? 'active' : ''"
      @click="redirectToUserProcess(option)"
    >
      {{ showConvertedString(option) }}
    </p>
    <div
      class="spinner-border text-secondary loader"
      role="status"
      v-show="loading"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </h1>
</template>

<script>
import { pl } from "vuejs-datepicker/dist/locale";
import { tasksNavigationOptions } from "@/utils/options.js";
export default {
  props: ["current"],
  name: "UserProcessNav",
  //: { ManagementPanel, Pagination },
  data() {
    return {
      pl: pl,
      tasksNavigationOptions: tasksNavigationOptions,
      loading: false,
    };
  },

  async mounted() {
    this.loading = true;
    await this.$store.dispatch("fetchProcesTypes");
    await this.$store.dispatch("fetchProcesSettings");

    setTimeout(() => {
      this.loading = false;
    }, 1500);
  },

  methods: {
    redirectToUserProcess(process) {
      if (process === "TASKS") this.$router.push({ name: "Tasks" });
      else {
        this.$router.push({
          name: "UserProcess",
          query: { type: process },
        });
      }
    },
    showConvertedString(type) {
      if (type === "INITIALIZED_ORDER") return "Zainicjowani";
      if (type === "CUSTOMER_SUCCESS") return "Customer Success";
      if (type === "REJECTED_BY_ADMIN") return "Odrzucone przez admina";
      if (type === "WITHOUT_VERIFICATION_PAYMENT")
        return "Niedokończona/nierozpoczęta płatność";
      else return type;
    },
  },

  computed: {
    processTypes() {
      return this.$store.getters.getProcessTypes;
    },
  },
};
</script>

<style scoped>

.title p {
  font-weight: 300;
  cursor: pointer;
}
.title .active {
  font-weight: 600;
  position: relative;
}
.title .active::after{
  content: '';
  position: absolute;
  bottom: -20px;
  width: 100%;
  height: 2px;
  background: #FB8929;
  left: 0;
}
</style>
